/**
 * Decorative corner flourish SVG component for parchment borders.
 */
export function CornerFlourish({ className = '' }: { className?: string }) {
    return (
        <svg
            className={`w-8 h-8 text-amber-800/20 ${className}`}
            viewBox="0 0 100 100"
            fill="currentColor"
        >
            <path d="M0,0 Q50,10 50,50 Q10,50 0,0 M10,0 Q40,20 40,40 Q20,40 10,0" />
        </svg>
    );
}
